import { toast, TypeOptions } from 'react-toastify'
import { ReactNode } from 'react'

export function showErrorToast(message: ReactNode) {
  showToast(message, 'error')
}

export function showSuccessToast(message: ReactNode) {
  showToast(message, 'success')
}

export function showToast(message: ReactNode, type: TypeOptions) {
  toast(message, {
    containerId: 'service',
    hideProgressBar: true,
    type,
    autoClose: 5000,
  })
}
